import { useState } from 'react';
import { Icon } from './icon';

interface StarsProps {
  value?: number;
  onRate?: (n: number) => void;
  size?: number;
  readOnly?: boolean;
}

export function Stars({ value = 0, onRate, size = 34, readOnly }: StarsProps) {
  const [hover, setHover] = useState(0);
  return (
    <div
      className="wb-row wb-gap-6"
      role={readOnly ? 'img' : 'radiogroup'}
      aria-label={`Rating ${value} of 5`}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const on = (hover || value) >= n;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => onRate?.(n)}
            style={{
              background: 'none',
              border: 'none',
              cursor: readOnly ? 'default' : 'pointer',
              padding: 2,
              color: on ? 'var(--honey)' : 'var(--line-2)',
              transition: 'color .12s, transform .12s',
              transform: on && !readOnly ? 'scale(1.06)' : 'none',
            }}
          >
            <Icon name={on ? 'starFill' : 'star'} size={size} />
          </button>
        );
      })}
    </div>
  );
}
